const WeatherRiskRecommendations = ({ recommendations }) => {
  if (!recommendations?.length) {
    return null;
  }

  return (
    <section className="weather-risk-recommendations">
      <h4>What this means</h4>
      <ul>
        {recommendations.map((entry) => (
          <li key={entry.text}>{entry.text}</li>
        ))}
      </ul>
    </section>
  );
};

export default WeatherRiskRecommendations;
